import { ChangeEvent, useCallback, useMemo, useState } from 'react';
import { IssueReportPriority } from 'api/submitIssueReport';

export interface IssueReportDraft {
  title: string;
  description: string;
  priority: IssueReportPriority;
  files: File[];
}

const useReportAnIssueFormState = () => {
  const [title, setTitle] = useState<string>('');
  const onTitleChanged = useCallback((event: ChangeEvent<HTMLInputElement>) => {
    setTitle(event.target.value);
  }, []);

  const [description, setDescription] = useState<string>('');
  const onDescriptionChanged = useCallback(
    (event: ChangeEvent<HTMLTextAreaElement>) => {
      setDescription(event.target.value);
    },
    [],
  );

  const [priority, setPriority] = useState<IssueReportPriority>('');

  const [files, setFiles] = useState<File[]>([]);

  const reset = useCallback(() => {
    setTitle('');
    setDescription('');
    setPriority('');
    setFiles([]);
  }, []);

  const draft = useMemo<IssueReportDraft | undefined>(() => {
    if (title.trim() === '' || description.trim() === '') {
      return undefined;
    }
    return {
      title: title.trim(),
      description: description.trim(),
      priority,
      files,
    };
  }, [title, description, priority, files]);

  return {
    title,
    onTitleChanged,
    description,
    onDescriptionChanged,
    priority,
    setPriority,
    files,
    setFiles,
    draft,
    reset,
  };
};

export default useReportAnIssueFormState;
